
<div>
    <!--
    <div class="group-label">
        {{ $t('unit.group.posInGroup') }}
    </div>
    -->

    <div class="w-100 text-center" style="height: 18px; font-size: 15px;">
        {{ position }}
    </div>

    <div class="w-100 v-flex mt-2" style="justify-content: center">
        <div
            class  ="secondary lighten-4 group-room"
            :style = "height"
        >
            <div style="width: 60px; position: absolute; top: 40px; left: 8px" v-if="typeOfGroup">
                <v-card
                    v-for  = "index in posmap[typeOfGroup-1]"
                    :key   = "index"
                    class  = "group-entry mb-1"
                    :class = "(index < posmap[typeOfGroup-1] ? 'mr-2 ' : '') + (index === selected.left ? 'primary' : '')"
                    @click = "onClickLeft(index)"
                    flat
                >
                    <v-icon
                        size="28"
                        class="text-grey-lighten-"
                        style="margin-top: -3px"
                        :color="index === selected.left ? 'white' : 'secondary lighten-4'"
                    >
                        mdi-elevator-passenger
                    </v-icon>
                </v-card>
            </div>

            <div class="text-primary group-room-entry">
                Eingang
            </div>

            <div style="padding-top: 8px; padding-left: 40px; position: absolute; top: 0" v-if="typeOfGroup">
                <div class="v-flex">
                    <v-card
                        v-for   = "index in posmap[typeOfGroup-1]"
                        :key    = "index"
                        class   = "group-entry "
                        :class  = "(index < posmap[typeOfGroup-1] ? 'mr-1 ' : '') + (index === selected.bottom ? 'primary' : '')"
                        @click  = "onClickBottom(index)"
                        flat
                    >
                        <v-icon
                            size   = "28"
                            class  = ""
                            style  = "margin-top: -3px"
                            :color = "index === selected.bottom ? 'white' : 'secondary lighten-4'"
                        >
                            mdi-elevator-passenger
                        </v-icon>
                    </v-card>
                </div>

            </div>

            <div style="width: 32px; position: absolute; top: 40px; right: 8px" v-if="typeOfGroup">
                <v-card
                    v-for   = "index in posmap[typeOfGroup-1]"
                    :key    = "index"
                    class   = "group-entry mb-1"
                    :class  = "(index < posmap[typeOfGroup-1] ? 'mr-2 ' : '') + (index === selected.right ? 'primary' : '')"
                    @click  = "onClickRight(index)"
                    flat
                >
                    <v-icon
                        size="28"
                        class="text-grey-lighten-"
                        style="margin-top: -3px"
                        :color="index === selected.right ? 'white' : 'secondary lighten-4'"
                    >
                        mdi-elevator-passenger
                    </v-icon>
                </v-card>
            </div>
        </div>
    </div>
</div>
